import CryptoJS from "crypto-js";

const poolData = {
  UserPoolId: "us-east-2_dgBGxBynT",
  ClientId: "7mrd6pd7813aa28o4fde380seb",
  ClientSecret: "708k5ntabe2pj6daigfoebjq2s62oicstaf03usjfk4fpog8ho",
};

const REGION = "us-east-2";

const getSecretHash = (username) => {
  const secretHash = CryptoJS.HmacSHA256(username + poolData.ClientId, poolData.ClientSecret).toString(
    CryptoJS.enc.Base64
  );
  return secretHash;
};

export const isTokenExpired = (token) => {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    const currentTime = Math.floor(Date.now() / 1000);
    return payload.exp < currentTime; 
  } catch (err) {
    console.error('Error decoding token:', err);
    return true;
  }
};

export const login = async (username, password, newPassword = null) => {
  try {
    const response = await fetch(`https://cognito-idp.${REGION}.amazonaws.com/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-amz-json-1.1',
        'X-Amz-Target': 'AWSCognitoIdentityProviderService.InitiateAuth',
      },
      body: JSON.stringify({
        AuthFlow: 'USER_PASSWORD_AUTH',
        ClientId: poolData.ClientId,
        AuthParameters: {
          USERNAME: username,
          PASSWORD: password,
          SECRET_HASH: getSecretHash(username),
        },
      }),
    });

    const data = await response.json();

    if (data.ChallengeName === 'NEW_PASSWORD_REQUIRED') {
      // Handle new password challenge
      if (!newPassword) {
        throw new Error('NEW_PASSWORD_REQUIRED: User must set a new password.');
      }

      const challengeResponse = await fetch(`https://cognito-idp.${REGION}.amazonaws.com/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-amz-json-1.1',
          'X-Amz-Target': 'AWSCognitoIdentityProviderService.RespondToAuthChallenge',
        },
        body: JSON.stringify({
          ChallengeName: 'NEW_PASSWORD_REQUIRED',
          ClientId: poolData.ClientId,
          Session: data.Session,
          ChallengeResponses: {
            USERNAME: username,
            NEW_PASSWORD: newPassword,
            SECRET_HASH: getSecretHash(username),
          },
        }),
      });

      const challengeResult = await challengeResponse.json();

      if (!challengeResult.AuthenticationResult) {
        throw new Error('Failed to complete NEW_PASSWORD_REQUIRED challenge.');
      }

      const { AccessToken, IdToken, RefreshToken } = challengeResult.AuthenticationResult;
      localStorage.setItem('accessToken', AccessToken);
      localStorage.setItem('idToken', IdToken);
      localStorage.setItem('refreshToken', RefreshToken);

      return { AccessToken, IdToken, RefreshToken };
    }

    // Normal login flow
    if (!data.AuthenticationResult) {
      throw new Error('Authentication failed. No tokens received.');
    }

    const { AccessToken, IdToken, RefreshToken } = data.AuthenticationResult;
    localStorage.setItem('accessToken', AccessToken);
    localStorage.setItem('idToken', IdToken);
    localStorage.setItem('refreshToken', RefreshToken);

    return { AccessToken, IdToken, RefreshToken };
  } catch (error) {
    console.error('Error during login:', error);
    throw error;
  }
};

  
  export const refreshToken = async () => {
    const refreshToken = localStorage.getItem('refreshToken');
    if (!refreshToken) {
      throw new Error('No refresh token available.');
    }
  
    const response = await fetch(`https://cognito-idp.${REGION}.amazonaws.com/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-amz-json-1.1',
        'X-Amz-Target': 'AWSCognitoIdentityProviderService.InitiateAuth',
      },
      body: JSON.stringify({
        AuthFlow: 'REFRESH_TOKEN_AUTH',
        ClientId: poolData.ClientId,
        AuthParameters: {
          REFRESH_TOKEN: refreshToken,
          SECRET_HASH: getSecretHash(localStorage.getItem('username')), // Store username for refresh
        },
      }),
    });
  
    const data = await response.json();
    if (!data.AuthenticationResult) {
      throw new Error('Failed to refresh token.');
    }
  
    const { AccessToken, IdToken } = data.AuthenticationResult;
    localStorage.setItem('accessToken', AccessToken);
    localStorage.setItem('idToken', IdToken);
    return AccessToken;
  };
  

  export const logout = () => {
    sessionStorage.removeItem('accessToken');
    sessionStorage.removeItem('idToken');
    sessionStorage.removeItem('refreshToken');
  };

export const getCurrentUser = () => {
    const accessToken = localStorage.getItem('accessToken');
    return accessToken ? { accessToken } : null;
  };
  
